export default __webpack_public_path__ + "static/media/post3.d1464a3c.jpg";